import { render } from "./ProgressSpinner.vue?vue&type=template&id=8c593c86&bindings={\"strokeWidth\":\"props\",\"fill\":\"props\",\"animationDuration\":\"props\",\"svgStyle\":\"options\"}"
import script from "./ProgressSpinner.vue?vue&type=script&lang=js"
export * from "./ProgressSpinner.vue?vue&type=script&lang=js"

import "./ProgressSpinner.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script